/// <amd-module name="Wit/WorkItemGitLinks/Components/Branch/BranchForm" />
import * as React from "react";
import { useCallback } from "react";
import { usePageContext } from "VSS/Platform/Layout";
import { FormItem } from "VSSUI/FormItem";
import { GitRef } from "VC/Common/Contracts/Git";
import { ILinkTypeSpecificFormProps } from "Wit/WorkItemGitLinks/Components/ILinkTypeSpecificFormProps";
import { branchToDisplayData } from "Wit/WorkItemGitLinks/GitLinkUtils";
import * as Resources from "Wit/WorkItemGitLinks/Resources";
import { RefPicker } from "../RefPicker";

export function BranchForm({ repository, onArtifactsUpdated }: ILinkTypeSpecificFormProps) {
    const pageContext = usePageContext();
    const onBranchRefChosen = useCallback(async (ref: GitRef) => {
        if (!repository) {
            return;
        }
        const artifact = branchToDisplayData(pageContext, ref, repository);
        return onArtifactsUpdated([artifact]);
    }, [repository]);

    return (
        <FormItem label={Resources.BranchSelectorLabel}>
            <RefPicker repository={repository} onSelect={onBranchRefChosen} excludeTags />
        </FormItem>
    );
}

